<button
  data-testid="button"
  tuiButton
  tuiDropdownAlign="end"
  type="button"
  [appearance]="appearance"
  [iconStart]="icon"
  [tuiDropdown]="dropdownContent"
  [(tuiDropdownOpen)]="open">
  <div class="flex gap-3">
    {{ actions[selectedKey]?.title }}
    <tui-icon class="transition-all duration-300" icon="@tui.chevron-down" [ngClass]="{ 'rotate-180': open }" />
  </div>
</button>

<ng-template #dropdownContent>
  <div class="flex min-w-64 flex-col p-2" data-testid="dropdown">
    @for (actionsKeyValue of actions | keyvalue; track actionsKeyValue.key) {
      <div class="flex cursor-pointer items-center rounded-xl p-2 hover:bg-background-primary-hover">
        @let action = actionsKeyValue.value;
        @if (action) {
          <div
            class="flex w-full items-center justify-between gap-2"
            [attr.data-testid]="action.testId"
            (click)="onClick(action)">
            <div class="flex items-center gap-3">
              @if (action.icon) {
                <tui-icon class="text-foreground-tertiary" [icon]="action.icon" />
              }
              <div class="flex flex-col">
                <p class="whitespace-normal">
                  {{ action.title }}
                </p>
                @if (action.label) {
                  <p class="whitespace-normal text-text-tertiary">
                    {{ action.label }}
                  </p>
                }
              </div>
            </div>
            <tui-icon
              class="text-foreground-tertiary"
              data-testid="action-check"
              icon="@tui.check"
              [class.invisible]="actionsKeyValue.key !== selectedKey" />
          </div>
        }
      </div>
    }
  </div>
</ng-template>
